<template>
    <div class="header-section">
        <p class="form-subtitle" style="cursor: pointer;" @click="$router.push('/schedule-court-list')">
            <i class="fa fa-arrow-left"></i> Back
        </p>
        <h1 class="form-title">Schedule Court</h1>
    </div>
    <div class="upload-toggle mb-3">
        <button
            type="button"
            :class="{ active: uploadMode === 'single' }"
            @click="uploadMode = 'single'"
        >
            Single Entry
        </button>

        <button
            type="button"
            :class="{ active: uploadMode === 'bulk' }"
            @click="uploadMode = 'bulk'"
        >
            Bulk Upload (Excel)
        </button>
    </div>

    <form @submit.prevent="submitForm" v-if="uploadMode === 'single'">
        <div class="setup-form">
                <div class="form-group">
                <label for="category">Court</label>
                <select id="category" required v-model="court">
                    <option disabled value="">-- Select --</option>
                    <option v-for="(data, index) in courtList" :key="index" :value="data.id">{{ data.name }}</option>
                </select>
                </div>

                <div class="form-group">
                <label for="category">Date</label>
                <input 
                    type="date" 
                    id="title"
                    required 
                    v-model="court_date"
                />
                </div>

                <div class="form-group">
                <label for="category">Start Time</label>
                <input 
                    type="time" 
                    id="title"
                    required 
                    v-model="start_time"
                />
                </div>
                <div class="form-group">
                <label for="category">End Time</label>
                <input 
                    type="time" 
                    id="title"
                    required 
                    v-model="end_time"
                />
                </div>
                
        </div>
        <div class="setup-form">
                
            <div class="form-group">
            <label for="category">Status</label>
            <select id="category" required v-model="court_status">
                <option disabled value="">-- Select --</option>
                <option value="available">Available</option>
                <option value="booked">Booked</option>
                <option value="maintenance">Maintenance</option>
            </select>
            </div>
                
        </div>
        <div class="buttons mt-3">
            <button>Submit</button>
        </div>
    </form>
    <form v-if="uploadMode === 'bulk'" @submit.prevent="submitBulkUpload">
        <div class="setup-form">

            <div class="form-group">
                <label>Upload Excel File</label>
                <input
                    type="file"
                    accept=".xlsx,.csv"
                    @change="handleFileUpload"
                    required
                />
                <a href="https://lagoslawntennisclub1895.com/court_schedule_bulk_upload_template.xlsx">Download sample template</a>
            </div>

            <!-- <div class="excel-guide">
                <p><strong>Excel format:</strong></p>
                <table class="excel-table">
                    <thead>
                        <tr>
                            <th>court_id</th>
                            <th>date</th>
                            <th>start_time</th>
                            <th>end_time</th>
                            <th>status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>2026-01-15</td>
                            <td>09:00</td>
                            <td>10:00</td>
                            <td>available</td>
                        </tr>
                    </tbody>
                </table>
            </div> -->

            <div class="buttons mt-5">
                <button >Upload & Process</button>
            </div>

        </div>
    </form>

</template>
<script setup>
/* eslint-disable */ 
import { CircleCheck, Image } from "lucide-vue-next";
import { ref, reactive, computed, onMounted, onBeforeUnmount } from "vue";
import axios from 'axios';
import router from "@/router";

const fileInput = ref(null);
const files = ref([]);
const dataList = ref([]);
const courtList = ref([])
let court = ref('');
let court_date = ref('');
let start_time = ref('');
let end_time = ref('');
let court_status = ref('')
const created_by = ref(localStorage.getItem('userid'));
const uploadMode = ref('single') // single | bulk
const bulkFile = ref(null)

onMounted( async () => {
  await listCourt();
  
});

function triggerFileInput() {
    fileInput.value.click();
}

function handleFileChange(event) {
    const selectedFile = event.target.files[0]; // only one banner at a time

    if (selectedFile) {
        const fileObj = reactive({
            name: selectedFile.name,
            file: selectedFile,
            progress: 0,
            preview: selectedFile.type.startsWith("image/")
                ? URL.createObjectURL(selectedFile)
                : null
        });
        files.value = [fileObj]; // replace with new file
    }

    event.target.value = "";
}

const listCourt= async () => {
  try {
    const response = await axios.get('/court_lists.php', { });
    if (response.data.status) courtList.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

async function submitForm() {

    const formData = new FormData();
    formData.append('court', court.value)
    formData.append("court_date", court_date.value);
    formData.append('start_time', start_time.value)
    formData.append("end_time", end_time.value);
    formData.append("court_status", court_status.value);
    formData.append("created_by", created_by.value);

    try {
        const response = await axios.post(
            "/schedule_court_setup.php", // change to your backend URL
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" },
                
            }
        );
            alert( response.data.message);
            court.value = "";
            court_date.value = "";
            start_time.value = "";
            end_time.value = "";
            court_status.value = "";
            router.push("/schedule-court-list");
    } catch (error) {
        console.error(error);
        alert(error.response ? error.response.data.message : error.message);
    }
}

const handleFileUpload=(event)=>{
    bulkFile.value = event.target.files[0]
}

const submitBulkUpload=()=>{
    if (!bulkFile.value) {
        alert('Please select an Excel file');
        return;
    }

    const formData = new FormData();
    formData.append('file', bulkFile.value);

    axios.post('/schedule_court_bulk_setup.php', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then(res => {
        alert('Bulk upload successful');
        router.push("/schedule-court-list");
        
    }).catch(err => {
        alert('Upload failed');
    });
}
</script>
<style scoped>
.upload-toggle {
    display: flex;
    gap: 10px;
}

.upload-toggle button {
    padding: 8px 16px;
    border: 1px solid #ddd;
    background: #f8f9fa;
    cursor: pointer;
    border-radius: 6px;
}

.upload-toggle button.active {
    background: #0d6efd;
    color: #fff;
    border-color: #0d6efd;
}

.excel-guide {
    margin-top: 15px;
    font-size: 13px;
}

.excel-table {
    width: 100%;
    border-collapse: collapse;
}

.excel-table th,
.excel-table td {
    border: 1px solid #ddd;
    padding: 6px;
    text-align: left;
}

.setup-form {
    max-width: 95%;
    margin: 0 auto;
    padding: 24px;
    display: flex;
    justify-content: between;
    gap: 24px;
    align-items: start;
}

.header-section {
    max-width: 90%;
    margin: 0 auto 20px auto;
}

.header {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
    width: 50%;
    box-shadow: #6C757D33 0px 1px 3px 0px, #6C757D1A 0px 1px 2px 0px;
    border: 1px solid #EBF1FF;
    border-radius: 20px;
    padding: 40px;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: start;
    width: 100%;
    margin-top: 20px;
}

.form-group label {
    font-size: 16px;
    color: #495057;
}

.form-group input {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #94A3B8;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
}

.form-group select {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #94A3B8;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
}

.form-group textarea {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #94A3B8;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
    resize: vertical;
}

.form-group input:focus {
    border-color: #4C6EF5;
}

.buttons {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    width: 90%;
    margin: 0 auto 40px auto;
}

.buttons button {
    flex: 1;
    padding: 12px 16px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
    outline: none;
    transition: background-color 0.3s, color 0.3s;
}

.buttons button:first-child {
    background-color: #FF1F25;
    color: #fff;
}

.buttons button:first-child:hover {
    background-color: #c92f34;
    color: #fff;
}

.buttons button:last-child {
    background-color: #ED4E24;
    color: #fff;
}

.buttons button:last-child:hover {
    background-color: #d35533;
    color: #fff;
}

.form-title {
    text-align: left;
    font-size: 24px;
    font-weight: 600;
    margin-top: 20px;
    color: #020617;
}

.form-subtitle {
    text-align: left;
    font-size: 16px;
    color: #020617;
    margin-bottom: 20px;
}

.upload-section {
    margin-top: 20px;
    padding: 20px;
    border: 2px dashed #ccc;
    border-radius: 12px;
    text-align: center;
    background: #fafafa;
    max-width: 90%;
    height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
}

.upload-section input[type="file"] {
    display: none;
}

.file-list-section {
    max-width: 90%;
    padding: 10px;
    margin: 15px auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.file-item {
    background-color: #FAFAFA;
    border: 1px solid #ccc;
    width: 50%;
    margin-top: 15px;
    text-align: left;
    border-radius: 8px;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
}

.file-name {
    font-size: 12px;
    font-weight: bold;
    color: #333;
    padding: 0%;
    margin: 0%;
    width: 20%;
}

.progress-container {
    height: 4px;
    width: 80%;
    background: #eee;
    border-radius: 10px;
    position: relative;
}

.progress-bar {
    height: 100%;
    background: red;
    border-radius: 10px;
    transition: width 0.3s;
}

.progress-container span {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    font-weight: bold;
    color: #fff;
}

.file-preview {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px;
}

@media (max-width: 768px) {
    .setup-form {
        flex-direction: column;
        padding: 0px;
        max-width: 100%;
        margin: 0%;
    }

    .header {
        width: 100%;
        padding: 20px;
    }

    .buttons {
        flex-direction: column;
        width: 100%;
        margin: 0 auto 20px auto;
    }

    .upload-section {
        margin-top: 20px;
        padding: 20px;
        max-width: 100%;
        height: auto;
        margin: 10px auto;
    }

    .file-list-section {
        max-width: 100%;
        padding: 8px;
        margin: 12px auto;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .file-item {
        background-color: #FAFAFA;
        border: 1px solid #ccc;
        width: 100%;
        margin-top: 15px;
        text-align: left;
        border-radius: 8px;
        padding: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 16px;
    }

}
</style>